import api from "./api";

export const whatsappApi = {
    getStatus: () => api.get("/tenant/whatsapp/status"),
    getQrcode: () => api.get("/tenant/whatsapp/qrcode"),
    disconnect: () => api.post("/tenant/whatsapp/disconnect", {}),
    clearSession: () => api.del("/tenant/whatsapp/session"),
    getStats: () => api.get("/tenant/whatsapp/stats"),

    listTemplates: () => api.get("/tenant/whatsapp/templates"),
    createTemplate: (body) => api.post("/tenant/whatsapp/templates", body),
    updateTemplate: (id, body) => api.patch(`/tenant/whatsapp/templates/${id}`, body),
    deleteTemplate: (id) => api.del(`/tenant/whatsapp/templates/${id}`),

    listConversations: () => api.get("/tenant/whatsapp/conversations"),
    getConversation: (phone) => api.get(`/tenant/whatsapp/conversations/${encodeURIComponent(phone)}`),
    sendToPhone: (phone, message, extra = {}) =>
        api.post(`/tenant/whatsapp/conversations/${encodeURIComponent(phone)}/send`, { phone, message, ...extra }),

    sendIndividual: (body) => api.post("/tenant/whatsapp/send/individual", body),
    sendBatch: (body) => api.post("/tenant/whatsapp/send/batch", body),
    batchProgress: (batchId) => api.get(`/tenant/whatsapp/send/batch/${batchId}/progress`),
    listBatches: () => api.get("/tenant/whatsapp/send/batches"),
};

export default whatsappApi;
